module.exports = __webpack_public_path__ + "img/btn-swiper-next-02.4a80ce04.svg";